import { useVIPEditorVIPByIdQuery } from '@graphql/generated';

export const useGetVipById = (id: string) => {
  const {
    data: dataRaw,
    loading,
    error,
  } = useVIPEditorVIPByIdQuery({
    variables: {
      id,
    },
    batchMode: 'fast',
  });

  return { data: dataRaw?.vip, loading, error };
};
